import React from 'react';
import CriteriaGroupNode from './CriteriaGroupNode';
import {
  appendChildAtPath,
  defaultCriteriaRoot,
  removeAtPath,
  updateNodeAtPath,
} from './criteriaUtils';
import './CriteriaBuilder.css';

const CriteriaBuilder = ({ criteria, onChange }) => {
  const root = criteria || defaultCriteriaRoot();

  const handleChange = (path, updater) => {
    onChange(updateNodeAtPath(root, path, updater));
  };

  const handleRemove = (path) => {
    onChange(removeAtPath(root, path));
  };

  const handleAppend = (path, child) => {
    onChange(appendChildAtPath(root, path, child));
  };

  return (
    <div className="criteria-builder">
      <p className="text-sm text-gray-500 mb-2">
        Pick columns from the catalog. Nest groups with <strong>AND</strong> / <strong>OR</strong>. Operators
        depend on column type (string, numeric, date, boolean, array).
      </p>
      <CriteriaGroupNode
        node={root}
        path={[]}
        onChange={handleChange}
        onRemove={handleRemove}
        onAppend={handleAppend}
      />
    </div>
  );
};

export default CriteriaBuilder;
